import React, { useState, useContext, useRef } from "react"
import { ChevronDown, ChevronUp } from "react-feather"
import { ModalContext } from "src/context/ModalContext"
import { useOutsideClicksHandler } from "src/hooks/use-outside-clicks-handler"

import Button from "src/components/core/atoms/button"
import Option from "./dropdown-option"

import {
  wrapper,
  header,
  headerTitle,
  list,
  listItem,
} from "./styles.module.css"

import { label as s_label } from "src/components/partials/booking/infoProducts/products.module.css"

const dateTimeFormatOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  hour12: true,
}

export const Dropdown = ( { label, options, value, onChange, args } ) => {
  const [ isOpen, setIsOpen ] = useState( false )

  const { openModal } = useContext( ModalContext )

  const wrapperRef = useRef( null )
  useOutsideClicksHandler( wrapperRef, setIsOpen )

  let dropdownHeader = "Select..."
  if ( args.elem === "address" && options && options[ value ] )
    dropdownHeader = options[ value ]?.nickname
  if ( args.elem === "time" && options && options[ value ] ) {
    dropdownHeader = new Intl.DateTimeFormat(
      "en-GB",
      dateTimeFormatOptions
    ).format( options[ value ] )
  }

  const handleKeyDown = e => {
    e.preventDefault()
    switch ( e.keyCode ) {
      case 39:
      case 40:
        // e.target.selectQuery( `div[tabindex=${ 0 }]` )
        console.log( e.target, "next item" )
        break
      case 37:
      case 38:
        console.log( "prev item" )
        break
      default:
        console.log( `Sorry, we are out of options.` )
    }
  }

  return (
    <div>
      {label && (
        <label className={ s_label } htmlFor={ `${ args.type }-${ args.elem }` }>
          {label }
        </label>
      ) }
      <div name={ args.type } className={ wrapper } ref={ wrapperRef }>
        {/* Dropdown Header */ }
        <button
          name={ `${ args.type }-${ args.elem }` }
          type="button"
          onClick={ () => setIsOpen( !isOpen ) }
          onKeyDown={ handleKeyDown }
          className={ header }
        >
          <div className={ headerTitle }>{ dropdownHeader }</div>
          { isOpen ? <ChevronUp /> : <ChevronDown /> }
        </button>
        { isOpen && (
          <section role="list" className={ list }>
            {/* Dropdown Options List */ }
            {options &&
              Object.entries( options ).map( ( option, i ) => (
                <Option
                  key={ i }
                  data={ option }
                  args={ args }
                  value={ value }
                  onChange={ onChange }
                  setIsOpen={ setIsOpen }
                />
              ) ) }
            {/* Dropdown Fixed Item - Add New */ }
            <div className={ listItem } role="listitem">
              <Button
                onClick={ () =>
                  openModal( {
                    variant:
                      args.elem === "address" ? "mapping" : "date & time",
                    isDefault: false,
                  } )
                }
                variant="underlined"
              >
                Add a new { args.elem === "address" ? "location" : "timing" }?
              </Button>
            </div>
          </section>
        ) }
      </div>
    </div>
  )
}

export default Dropdown
